import React, { Component } from 'react';

function PageFooterForGeneral(props) {
    let cy = new Date().getFullYear();
    return (
    
        <footer id="app-footer" className="mescius-bootstrap">
                <div className="container">
                    <div className="row test">
                        <div className="col-lg-4 brand">
                        <a href="/" className="logo"><i className="mesicon-logo-horiz"><span>MESCIUS</span></i></a>
                            <p>&copy;2025 MESCIUS USA, Inc. All rights reserved.<br />1.800.858.2739</p>
                            <p>All product and company names herein may be trademarks of their respective owners.</p>
                        </div>
                        <div className="col-lg-2 company">
                            <ul>
                                <li>Company</li>
                                <li><a href="https://developer.mescius.com/about" target="_blank">About</a></li>
                                <li><a href="https://developer.mescius.com/contact" target="_blank">Contact</a></li>
                                <li><a href="https://developer.mescius.com/about/media-center" target="_blank">Media Center</a></li>
                                <li><a href="https://developer.mescius.com/legal/privacy-policy" target="_blank">Privacy</a></li>
                                <li><a href="https://developer.mescius.com/legal/tos" target="_blank">Terms</a></li>
                                <li><a href="https://developer.mescius.com/legal/eula" target="_blank">EULA</a></li>
                            </ul>
                        </div>
                        <div className="col-lg-2 social">
                        </div>
                        <div className="col-lg-4 subscribe">
                            <ul>
                                <li>Get the Latest News</li>
                                <li>Stay up to date with blogs, eBooks, events, and whitepapers.</li>
                                <li><a href="https://developer.mescius.com/subscribe" className="gc-btn">Join Now</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </footer>
    );
}

export default PageFooterForGeneral;
